import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../lib/api';
import { ContactForm } from '../components/contacts/ContactForm';

export function ContactNouveauPage(): JSX.Element {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: api.contacts.create,
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: ['contacts'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      navigate(`/contacts/${String(data.contact.id)}`);
    },
    onError: (err: unknown) => {
      setError(err instanceof ApiError ? err.message : 'Erreur création contact.');
    },
  });

  return (
    <div className="max-w-5xl">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Nouveau contact</h1>
        <p className="text-xs text-slate-500 mt-1">Création d'un contact / prospect / client.</p>
      </header>

      {error !== null && (
        <div className="mb-4 text-xs text-red-300 bg-red-900/20 border border-red-900/50 rounded-md px-3 py-2">
          {error}
        </div>
      )}

      <ContactForm
        onSubmit={(body): void => mutation.mutate(body)}
        onCancel={(): void => navigate('/contacts')}
        submitting={mutation.isPending}
      />
    </div>
  );
}
